import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { hasBlocksData } from '@plone/volto/helpers';
import VideoViewer from '@plone/volto/components/manage/Blocks/Video/Body';
import RenderBlocks from 'volto-repeatable-content-block/helpers/RenderBlocks';
import DangerousHTML from 'rer-theme/helpers/DangerousHTML';

const messages = defineMessages({
  edit_script_info: {
    id: 'repeatable_content_block_edit_script_info',
    defaultMessage:
      "Se l'html contiene tag script può essere che questi non vengano eseguiti quando si sta editando la pagina. Salvare il contenuto e ricaricare la pagina per verificare che il contenuto scelto venga replicato correttamente.",
  },
});
const RenderContentContent = ({ content, edit }) => {
  const intl = useIntl();
  const blocks = hasBlocksData(content)
    ? RenderBlocks({ content: content })
    : null;

  if (content?.['@type'] === 'WildcardVideo') {
    return (
      <div className="block video">
        <VideoViewer data={{ url: content.video_url }} />
      </div>
    );
  }

  if (content?.['@type'] === 'RawHtml' && content.html_text) {
    return (
      <div className="raw-html-text">
        {edit && (
          <div
            style={{
              'font-size': '0.8rem',
              'font-style': 'italic',
              'text-align': 'center',
            }}
          >
            {intl.formatMessage(messages.edit_script_info)}
          </div>
        )}

        <DangerousHTML html={content.html_text} />
        {/* <div dangerouslySetInnerHTML={{ __html: content.html_text }} /> */}
      </div>
    );
  }

  return blocks;
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
RenderContentContent.propTypes = {
  content: PropTypes.objectOf(PropTypes.any),
};

export default RenderContentContent;
